import React from "react";

import { Route, Routes } from "react-router-dom";
import usePageTracking from "../../hooks/usePageTracking";

import Container from "./Container";
import SelectPlace from "./SelectPlace";
import ShowPlace from "./ShowPlace";
import ShowPlaceDetails from "./ShowPlaceDetails";

type PropsType = {
  csrfToken: string;
};

export default function ProviderSearch() {
  usePageTracking();

  return (
    <Container>
      <Routes>
        <Route path={`/`} element={<SelectPlace />} />
        <Route path={`/place`} element={<ShowPlace />} />
        <Route path={`/:id`} element={<ShowPlaceDetails />} />
      </Routes>
    </Container>
  );
}
